// extracted by mini-css-extract-plugin
module.exports = {"airport":"airport-1l7u6","time":"time-1LHzV","city":"city-1GLh-","date":"date-1HLpE","isMobile":"isMobile-5vr21","date_icon":"date_icon-1w4S3","time_iata":"time_iata-1E9Go"};